// extracted by mini-css-extract-plugin
export default {"grid":"qGr55I","container":"b55Xf6"};